module.exports = __webpack_public_path__ + "img/female_A_01.c5693d2f.png";